import { LocalLoadable } from '@g2-shared/components';
import { lazy } from 'react';

export const HomePage = LocalLoadable(lazy(() => import('../pages/home')));

export const SendMoneyPage = LocalLoadable(lazy(() => import('../pages/send-money')));

export const ShowTransactionPage = LocalLoadable(lazy(() => import('../pages/show')));

export const FailedTransactionPage = LocalLoadable(
  lazy(() => import('../pages/failed-transaction'))
);

export const CompletedTransactionPage = LocalLoadable(
  lazy(() => import('../pages/completed-transaction'))
);

export const TransactionsHistoryPage = LocalLoadable(
  lazy(() => import('../pages/transaction-history'))
);
